import { render, staticRenderFns } from "./FichePaysage.vue?vue&type=template&id=b50df28c&"
import script from "./FichePaysage.vue?vue&type=script&lang=js&"
export * from "./FichePaysage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports